<div class="tw:container tw:mx-auto">
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:pt-6">
    <div class="tw:w-full tw:px-[15px] tw:mb-4 tw:items-baseline">
      <label class="font-24 tw:font-normal">{{feedbackSurvey.feedbackSurveyTitle}}</label>
    </div>
    <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2 tw:items-baseline">
      <span class="font-14 tw:pr-4">{{themeService.siteContent.placementHeaderLabel}} Id</span>
      <label class="font-20 tw:font-normal">{{bookingId}}</label>
    </div>
    <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2 tw:flex tw:lg:justify-end tw:items-baseline">
      <span class="font-14 tw:pr-4">{{themeService.siteContent.placementHeaderLabel}} date</span>
      <label class="font-20 tw:font-normal"> {{startDate | date : 'dd MMM yyyy'}} - {{endDate | date : 'dd MMM yyyy'}}</label>
    </div>
    <div class="tw:w-full tw:px-[15px] tw:items-baseline">
      <span class="font-14 tw:pr-4">Subject</span>
      <label class="font-20 tw:font-normal">{{subject}}</label>
    </div>
  </div>

  <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">

    @if (initialLoadComplete && !submitted) {
      <div class="tw:flex-1 tw:px-[15px]">
        <tuition-feedback [survey]="feedbackSurvey" [showHeader]="false" (feedbackSubmitted)="feedbackSubmitted($event)"></tuition-feedback>
      </div>
    }

  </div>
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
    <div class="tw:w-full tw:px-[15px]">
      <thank-you-banner></thank-you-banner>
    </div>
  </div>
</div>